import "core-js/modules/es.array.push.js";
import Swiper from "swiper";
import { WOW } from 'wowjs';
import router from "../router";
export default {
  name: "AppService",
  methods: {
    toContactMe() {
      router.push("contact");
    }
  },
  mounted() {
    /* banner-swiper */
    new Swiper(".banner-swiper", {
      loop: true,
      // 循环模式选项
      effect: 'fade',
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      // 延迟加载
      lazy: {
        loadPrevNext: true
      },
      observer: true,
      //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });
    /* customer-swiper */
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
  }
};